<template>
  <section class="content-navigation">
    <nav
      class="content-navigation__container var-dark"
      :class="{ 'content-navigation__container--no-subnav': !showBottom }"
    >
      <div v-if="showTop" class="container">
        <div class="content-navigation__top">
          <div class="content-navigation__dropdown">
            <slot name="dropdown" />
          </div>
          <div class="content-navigation__filters">
            <slot name="filters" />
          </div>
        </div>
      </div>
      <div v-if="showBottom" class="content-navigation__bottom">
        <slot name="subnavigation" />
      </div>
    </nav>
  </section>
</template>

<script setup lang="ts">
import { computed, useSlots } from 'vue';

const slots = useSlots();

const showTop = computed(() => {
  const dropdown = slots.dropdown?.() || [];
  const filters = slots.filters?.() || [];

  return dropdown.length > 0 || filters.length > 0;
});

const showBottom = computed(() => {
  const subnavigation = slots.subnavigation?.() || [];

  return subnavigation.length > 0;
});
</script>

<style lang="scss">
@import './scss/ContentNavigationWrapper.scss';
</style>
